<template>
  <j-modal :title="title" :width="1000" :visible="visible" :confirmLoading="confirmLoading"
    :maskClosable="false" :body-style="{ height: '650px', overflow: 'hidden', overflowY: 'scroll' }"
    @cancel="handleCancel" :okText="$t('确定')" :cancelText="$t('关闭')" :okButtonProps="{ class:{'jee-hidden': disableSubmit} }">
    <a-spin :spinning="confirmLoading">
      <div>
        <a-divider orientation="left">{{ $t('巡检计划信息') }}</a-divider>
        <detail-list>
          <detail-list-item :term="$t('计划类型')">{{filterDictTextByCache('plan_type',model.planType)}}</detail-list-item>
          <detail-list-item :term="$t('计划名称')">{{model.planName}}</detail-list-item>
          <detail-list-item :term="$t('计划类别')">{{model.planCategory == 0?$t('重点区域'):model.planCategory == 1?$t('查漏专项'):''}}</detail-list-item>
          <detail-list-item :term="$t('计划区域')">{{model.planArea}}</detail-list-item>
          <detail-list-item :term="$t('计划周期')">{{model.customCycleValue+' '+filterDictTextByCache('customCycleType',model.customCycleType)}}</detail-list-item>
          <detail-list-item :term="$t('测点实体')">{{filterDictTextByCache('planEntitiy',model.planEntitiy)}}</detail-list-item>
          <!-- <detail-list-item term="是否反馈">{{model.isFeedback == 0?'是':model.isFeedback == 1?'否':''}}</detail-list-item>
          <detail-list-item term="是否常规">{{model.isRoutine == 0?'是':model.isRoutine == 1?'否':''}}</detail-list-item> -->
          <detail-list-item :term="$t('巡检方式')">{{model.planManner == 0?$t('步巡'):model.planManner == 1?$t('车巡'):''}}</detail-list-item>
          <detail-list-item :term="$t('其他指标')">{{model.planOtherRequest}}</detail-list-item>
          <detail-list-item :term="$t('巡检要求')">{{model.planRequest}}</detail-list-item>
          <detail-list-item :term="$t('是否自动分派')">{{model.izAutoAssign == 1 ? $t('是') : $t('否')}}</detail-list-item>
          <detail-list-item :term="$t('实施人类型')" v-if="model.izAutoAssign == 1">{{model.taskImplementType == 0 ? $t('指定班组') : model.taskImplementType == 1 ? $t('直接指定实施人员') : ''}}</detail-list-item>
          <detail-list-item :term="$t('实施人员')" v-if="model.izAutoAssign == 1">{{model.taskImplementName}}</detail-list-item>
        </detail-list>
        <!-- <div v-for="(item,index) in model.inspectionRouteVOList && model.inspectionRouteVOList" class="device-box">
          <a-divider orientation="left">巡检路线{{++index}}</a-divider>
          <detail-list>
            <detail-list-item term="路线名称">{{item.routeName}}</detail-list-item>
            <detail-list-item term="路线类型">{{item.routeType == 0?'管线':''}}</detail-list-item>
            <detail-list-item term="里程数">{{item.routeMileage}}</detail-list-item>
          </detail-list>
          <div v-for="(cld,cldindex) in item.inspectionTaskRouteDeviceList && item.inspectionTaskRouteDeviceList" class="device-box">
            <a-divider orientation="left">设备{{++cldindex}}</a-divider>
            <detail-list>
              <detail-list-item term="设备名称">{{cld.deviceName}}</detail-list-item>
              <detail-list-item term="设备经度">{{cld.detectLongitude}}</detail-list-item>
              <detail-list-item term="设备纬度">{{cld.detectLatitude}}</detail-list-item>
              <detail-list-item term="检测类型">{{cld.detectType == 0?'设备':''}}</detail-list-item>
              <detail-list-item term="检测实体">{{cld.detectEntity}}</detail-list-item>
              <detail-list-item term="检测内容">{{cld.detectContent}}</detail-list-item>
            </detail-list>
          </div>
        </div> -->
        <a-divider orientation="left">{{ $t('路线-设备信息') }}</a-divider>
        <a-table ref="table" size="middle" :scroll="{x:true}" bordered rowKey="id" :columns="columns1"
          :dataSource="dataSource1" :loading="loading" :pagination="false" class="j-table-force-nowrap">
        </a-table>
      </div>
    </a-spin>
  </j-modal>
</template>

<script>
  // import {
  //   JeecgListMixin
  // } from '@/mixins/JeecgListMixin';
  import {
    httpAction,
    getAction
  } from '@/api/manage'
  import {
    validateDuplicateValue
  } from '@/utils/util'
  import DetailList from '@/components/tools/DetailList'
  const DetailListItem = DetailList.Item
  import {
    filterDictTextByCache
  } from '@/components/dict/JDictSelectUtil';
  export default {
    // mixins: [JeecgListMixin],
    name: 'inspectionPlanDetailModal',
    components: {
      DetailList,
      DetailListItem
    },
    data() {
      return {
        filterDictTextByCache: filterDictTextByCache,
        title: '',
        width: 800,
        visible: false,
        disableSubmit: true,
        confirmLoading: false,
        model: {},
        url: {
          queryById: "/jeecg-engineering/inspection/inspectionPlan/queryById",
          queryTableById: "/jeecg-engineering/inspection/inspectionPlan/queryTableById"
        },
        // 表头
        dataSource1: [],
        loading: false,
      }
    },
    computed: {
      columns1() {
        return [{
            title: '#',
            dataIndex: '',
            key: 'rowIndex',
            width: 60,
            align: "center",
            customRender: (t, r, index) => {
              return parseInt(index) + 1;
            }
          },
          {
            title: this.$t('路线名称'),
            align: "center",
            dataIndex: 'routeName'
          },
          {
            title: this.$t('设备编号'),
            align: "center",
            dataIndex: 'deviceNum'
          },
          {
            title: this.$t('设备类型'),
            align: "center",
            dataIndex: 'deviceType',
            customRender: (t, r, indnx) => {
              return filterDictTextByCache('deviceType', t)
            }
          },
          {
            title: this.$t('设备名称'),
            align: "center",
            dataIndex: 'deviceName'
          },
          {
            title: this.$t('设备经度'),
            align:"center",
            dataIndex: 'detectLongitude'
          },
          {
            title: this.$t('设备纬度'),
            align:"center",
            dataIndex: 'detectLatitude'
          },
          // {
          //   title: '是否正常',
          //   align: "center",
          //   dataIndex: 'isOk',
          //   customRender: function(t, r, indnx) {
          //     if (t == 0) {
          //       return '正常';
          //     } else if (t == 1) {
          //       return '异常';
          //     }
          //   }
          // },
          // {
          //   title: '结果描述',
          //   align: "center",
          //   dataIndex: 'resultDescription',
          //   scopedSlots: {
          //     customRender: 'resultDescription'
          //   }
          // }
        ]
      },
    },
    methods: {
      init(row) {
        this.title = this.$t('详情');
        this.visible = true;
        getAction(this.url.queryById, {
          id: row.id
        }).then(res => {
          this.model = res.result;
        });
        this.loading = true;
        getAction(this.url.queryTableById, {
          id: row.id
        }).then(res => {
          if (res.success) {
            this.loading = false;
            this.dataSource1 = res.result;
          }
        });
      },
      close() {
        this.$emit('close');
        this.visible = false;
      },
      handleCancel() {
        this.close()
      },
    }
  }
</script>
<style scoped>
</style>